export const SearchParamKeys = {
  entityType: 'entity-type',
  orderBy: 'orderBy',
  direction: 'direction',
  category: 'category',
  attribute: 'attribute',
  attributeIdentifier: 'attributeIdentifier',
  attributeType: 'attributeType',
  query: 'query',
  operator: 'operator',
  not: 'not',
  logicalOperator: 'logicalOperator',
  page: 'page',
  exportId: 'export-id',
  product: 'product',
  caseHandle: 'caseHandle',
  statusCode: 'statusCode',
  assigneeUserId: 'assigneeUserId',
  rationaleCode: 'rationaleCode',
};
